<template>
    <div>
        <page-header :title="title" :items="items" />

        <div v-if="!editMode || (editMode && form.id)" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <add-edit-form
                            v-model="form"
                            :edit-mode="editMode"
                            :validation="$v"
                            :server-errors="serverErrors"
                        />
                    </div>
                </div>

                <questions-management
                    v-if="editMode"
                    :form-id="id"
                    :questions="form.questions"
                    class="mt-3"
                />

                <div v-if="editMode" class="card mt-3">
                    <div class="card-body">
                        <h5 class="col-12 text-uppercase bg-light py-1">
                            Submissions
                        </h5>
                        <submissions-table :form-id="id" />
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-3">
                            <button
                                class="btn btn-success btn-static waves-effect waves-light m-1"
                                @click="submitHandler"
                            >
                                <i class="fas fa-save" />
                                Save
                            </button>
                        </div>

                        <item-information
                            :edit-mode="editMode"
                            :sections="sections"
                            :item="form"
                            @on-delete-confirm="onDeleteConfirm"
                        />
                    </div>
                </div>
            </div>
        </div>
        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';
import { required } from 'vuelidate/lib/validators';
import AddEditForm from '@/components/forms/AddEditForm';
import SubmissionsTable from '@/components/forms/submissions/Table';
import ItemInformation from '@/components/elements/ItemInformation';
import QuestionsManagement from '@/components/forms/QuestionsManagement';

export default {
    page: {
        title: 'Manage Form'
    },

    validations: {
        form: {
            name: {
                required
            }
        }
    },

    components: {
        AddEditForm,
        ItemInformation,
        SubmissionsTable,
        QuestionsManagement
    },

    data() {
        const { id = null } = this.$route.params;

        return {
            title: id ? 'Edit form' : 'Add form',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Forms',
                    to: '/forms'
                },
                {
                    text: id ? 'Edit' : 'Add',
                    active: true
                }
            ],
            id,
            editMode: !!id,
            form: {
                loggedInOnly: false,
                hideTitle: false
            },
            serverErrors: []
        };
    },

    computed: {
        sections() {
            const sections = {};

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        }
    },

    async created() {
        if (this.editMode) {
            try {
                this.form = await this.getForm(this.id);
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    },

    methods: {
        ...mapActions({
            addForm: 'forms/store',
            deleteForm: 'forms/destroy',
            getForm: 'forms/show',
            updateForm: 'forms/update'
        }),

        async submitHandler() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                if (!this.editMode) {
                    const added = await this.addForm(this.form);

                    this.$router.push(`/forms/${added.id}/edit`);
                } else {
                    const form = await this.updateForm({
                        id: this.id,
                        data: this.form
                    });

                    this.form.updatedAt = form.updatedAt;
                    this.formValueStringify = JSON.stringify(this.form);

                    this.$toaster('Form updated!');
                }
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        async onDeleteConfirm() {
            try {
                await this.deleteForm(this.id);

                this.$router.push('/forms');
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
